import {HttpHandlerService} from "./HttpHandlerService";
import {ApplicationSettingService} from "./ApplicationSettingService";
import {CustomField} from "../entities/CustomFieldName";
import {Asset} from "../entities/Asset";
import { StateService } from "@uirouter/angularjs";

export class CustomFieldNameService extends HttpHandlerService {
    static $inject = ['$http','$q','$state','localStorageService','ApplicationSettingService'];
    constructor($http:ng.IHttpService,
        $q: ng.IQService, $state: StateService,
                public locStorage:angular.local.storage.ILocalStorageService,
                public applicationSettingService:ApplicationSettingService) {
        super($http, $q, $state);
    }
    protected getBaseUrl():string{
        return "customfield";
    }
    updateAll(cfns:CustomField[]):ng.IPromise<boolean>{
        return this.usePutHandler(this.getBasesUrl(),"", cfns).then((data)=>{
            return this.$q.when(true);
        });
    }
    getColumnDefs(columnDefsName:string):ng.IPromise<[string,string,number][]>{
        var nvps:[string,string,number][] = this.locStorage.get<[string,string,number][]>(columnDefsName);
        if (nvps != null) {
            return this.$q.when<[string,string,number][]>(nvps);
        }
        else {
            return this.$q.all([
                this.getAll(),
                this.applicationSettingService.getCached()
            ])
                .then((data:any)=> {
                    var nameValuePairs:[string,string,number][] = [];
                    var columns:string[] = data[1][columnDefsName].split(",");
                    var customFieldNames:CustomField[] = [];
                    $.each(data[0], (index, jcfn)=> {
                        var cfn = CustomField.parseJson(jcfn);
                        customFieldNames.push(cfn);
                    });
                    $.each(columns, (i, col)=> {
                        var nameValue:[string,string,number] = [col, col, 230];
                        nameValue[1] = nameValue[1].charAt(0).toUpperCase() + nameValue[1].slice(1);
                        if (col == "vTagID") {
                            nameValue[1] = "V-Tag ID";
                        }
                        if (col == "vTagGpsDeviceID") {
                            nameValue[1] = "V-Tag GPS Device ID";
                        }
                        else if(col == "parentVTagID")
                            nameValue[i] = "Parent V-Tag ID";
                        else if(col =="rfidTag"){
                            nameValue[1] = "RFID Tag";
                        }
                        else if(col =="locationName"){
                            nameValue[1] = "Location Name";
                        }
                        else if(col =="locationSite"){
                            nameValue[1] = "Location Site";
                        }
                        else if(col =="locationBuilding"){
                            nameValue[1] = "Location Building";
                        }
                        else if(col =="locationFloor"){
                            nameValue[1] = "Location Floor";
                        }
                        else if(col =="locationRoom"){
                            nameValue[1] = "Location Room";
                        }
                        else if(col =="locationDescription"){
                            nameValue[1] = "Location Description";
                        }
                        else if(col == "lastGPSFix")
                            nameValue[1] = "Last GPS Fix";
                        else if(col == "lastObservedTime")
                            nameValue[1] = "Last Observed Time";
                        else if(col == "lastModified")
                            nameValue[1] = "Last Modified";
                        else if(col == "vTagLastSeen")
                            nameValue[1] = "V-Tag Last Seen";
                        else if(col === "vTagLastMoved")
                            nameValue[1] = "V-Tag Last Moved";
                        else if(col == "gpsAccuracy")
                            nameValue[1] = "GPS Accuracy";
                        else {
                            for(var i=0; i< customFieldNames.length; i++){
                                var cfn = customFieldNames[i];
                                var assetcolname = ("asset." + col).toLowerCase();
                                if (assetcolname == cfn.name.toLowerCase()) {
                                    nameValue[1] = cfn.value;
                                    break;
                                }
                            }
                        }
                        nameValuePairs.push(nameValue);
                    });
                    this.locStorage.set<[string,string,number][]>(columnDefsName, nameValuePairs);
                    return this.$q.when<[string,string,number][]>(nameValuePairs);
                });
        }
    }
    getVTagColumnDefs():ng.IPromise<[string,string,number][]> {
        return this.getColumnDefs("vTagPopupDisplayRows");
    }
    getAssetColumnDefs():ng.IPromise<[string,string,number][]> {
        return this.getColumnDefs("assetDisplayColumns");
    }
    getAssetReportSql(assets:any[]):ng.IPromise<string> {
        //var returnPromise:ng.IPromise<string>;
        return this.getAll().then((customFieldNames)=>{
            if(assets == null || assets.length == 0)
                return this.$q.when<string>("*");
            else{
                var asset = assets[0]
                var sql = null;
                for(var col in asset){
                    if(col == "$$hashKey" || typeof asset[col] === "function")
                        continue;
                    var colVal = "IFNULL("+col+",'') as [" + col + "]";
                    for(var i=0; i< customFieldNames; i++){
                        var cfn = customFieldNames[i];
                        var tempColVal = "asset." + col;
                        if (tempColVal == cfn.name) {
                            colVal = "IFNULL("+col+",'') as [" +cfn.value + "]";
                            break;
                        }
                    }
                    if(sql == null)
                        sql = colVal;
                    else
                        sql += "," + colVal;
                }
                return this.$q.when<string>(sql);
            }
        })
    }

    getOtherReportSql(items:any[]):string {
        if(items == null || items.length == 0)
            return " * " ;
        else{
            var item = items[0]
            var sql = null;
            for(var col in item){
                if(col == "$$hashKey" || typeof item[col] === "function")
                    continue;
                var colVal = "IFNULL(["+col+"],'') as [" + col + "]";
                if(sql == null)
                    sql = colVal;
                else
                    sql += "," + colVal;
            }
            return sql;
        }
    }

    getAll():ng.IPromise<any> {
        var config:any = {};
        return this.useGetHandler(this.getBasesUrl(),"", config);
    }
}
